import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../utils/api";
import { AUTH_LOGOUT } from "../../reducers/authReducer";


//PAGE RÉSERVÉE AUX MEMBRES CONNECTÉS
//- pas connecté : redirection vers la page de connexion (puis retour ici après connexion)
//- jeton enregistré mais refusé par le serveur (compte supprimé…) : déconnexion
//Rappel : la vraie protection est côté serveur (middlewares/auth.js), ceci évite juste d'afficher une page inutilisable.
function ProtectedRoute({ children }) {

  const auth = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const location = useLocation();
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (!auth?.token) return;
    const checkSession = async () => {
      try {
        const response = await fetch(`${API_URL}/authRoute/me`, { headers: { Authorization: `Bearer ${auth.token}` } });
        if (response.status === 401) {
          dispatch({ type: AUTH_LOGOUT });
          return;
        }
      } catch (error) {
        //Serveur injoignable : on laisse l'accès, les appels au serveur échoueront de toute façon
      }
      setIsChecked(true);
    };
    checkSession();
  }, [auth?.token, dispatch]);

  if (!auth?.token) {
    return <Navigate to="/signIn" replace state={{ from: location.pathname }} />
  }

  //Pendant la vérification de la session, rien ne s'affiche (quelques millisecondes)
  if (!isChecked) return null;

  return children;
};

export default ProtectedRoute;
